import { HStack } from '@chakra-ui/react';

import Button from 'components/_core/Button';

import locales from './locales';

interface EpAgreementWallProps {
  onPrev: () => void;
}

const EpAgreementWallHeader = ({ onPrev }: EpAgreementWallProps) => {
  return (
    <HStack h="full" padding="space-24">
      <Button
        icon="arrow-left"
        iconPosition="left"
        onClick={onPrev}
        size="sm"
        variant="tertiary"
      >
        {locales.back}
      </Button>
    </HStack>
  );
};

export default EpAgreementWallHeader;
